"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const SupportingCreativeFormatPlaybackTimeItem_1 = require("./SupportingCreativeFormatPlaybackTimeItem");
class SupportingCreativeFormatPlaybackTime {
    constructor({ id, availables, }) {
        this.toJSON = () => ({
            id: this.id,
            availables: this.availables.toJSON(),
        });
        this.id = id;
        this.availables = availables;
    }
}
SupportingCreativeFormatPlaybackTime.fromJSON = (json) => {
    const { id, availables } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (!Array.isArray(availables))
        throw new Error('.availables must be an array');
    return new SupportingCreativeFormatPlaybackTime({
        id,
        availables: immutable_1.List(availables).map((item) => SupportingCreativeFormatPlaybackTimeItem_1.default.fromJSON(item)),
    });
};
exports.default = SupportingCreativeFormatPlaybackTime;
